export default "__VITE_ASSET__4c77bd9e__"